// extracted by mini-css-extract-plugin
export default {"container":"Personal_container__IDqiG","wrapper":"Personal_wrapper__VGiyj"};